import React from 'react';
import Seo from './common/Seo';

import CallToAction from "./common/CallToAction";
import Drawer from "./common/Drawer";
import PageTitle from "./common/PageTitle";
import { routeIds } from "./i18n/routes";
import { useI18n } from "./i18n/I18nContext";

import Content from "./projects/Content";

function Projects({route}) {
  const { pathFor, t } = useI18n();
  const title = t("pages.projects.title");
  const description = t("pages.projects.description");

  return [
    <Seo title={title} description={description} />,
    <PageTitle id="realisations" title={t("pages.projects.heading")} text={t("pages.projects.intro")} />,
    <Content />,
    <CallToAction id="contact" title={t("pages.projects.ctaTitle")} text={t("pages.projects.ctaText")} action={t("common.contactUs")} href={pathFor(routeIds.contact)} />,
    <Drawer route={route} />
  ];
}

export default Projects;
